<template>
  <div
    class="modal fade"
    tabindex="-1"
    id="add-project-modal"
    ref="newTargetModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-950px">
      <div class="modal-content rounded">
        <BlockUI :loading="block" />
        <div class="modal-header">
          <h5 class="modal-title">{{ translate(title) }}</h5>

          <!--begin::Close-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
            @click="closeModal"
            aria-label="Close"
          >
            <i class="bi bi-x-lg"></i>
          </div>
          <!--end::Close-->
        </div>

        <div
          class="modal-body rounded p-0"
          style="padding-bottom: 1.5rem !important; background: #fbfbfb"
        >
          <Form
            v-slot="{ errors }"
            ref="refForm"
            id="add-project-form"
            class="form"
            novalidate="novalidate"
            @submit="saveData"
            :validation-schema="projectValidator"
          >
            <div>
              <div
                v-if="contentLanguages.length > 0"
                class="card-header card-header-stretch"
              >
                <div class="card-toolbar">
                  <ul
                    class="nav nav-tabs nav-line-tabs nav-stretch fs-5 border-0 text-nowrap flex-nowrap mw-850px ms-3"
                    style="overflow-x: auto; overflow-y: hidden"
                  >
                    <li class="nav-item mx-3">
                      <a
                        @click="activeLink = 'Standart'"
                        class="nav-link fs-6"
                        :class="`${activeLink === 'Standart' ? 'active langue-tabs-bold' : ''}`"
                        data-bs-toggle="tab"
                        href="#kt_tab_pane_1"
                        >{{ translate("project_modal_tab_info") }}</a
                      >
                    </li>
                    <li
                      v-for="(item, index) in contentLanguages"
                      :key="index"
                      class="nav-item mx-3"
                    >
                      <a
                        @click="activeLink = item.Value"
                        :class="`nav-link fs-6 ${activeLink === item.Value ? 'active langue-tabs-bold' : ''}`"
                        data-bs-toggle="tab"
                        :href="`#${item.Value}`"
                        >{{ item.Value }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body">
                <div
                  class="tab-content"
                  id="myTabContent"
                >
                  <div
                    class="tab-pane fade show active"
                    id="kt_tab_pane_1"
                    role="tabpanel"
                  >
                    <div class="row mb-4">
                      <label class="col-lg-4 col-form-label required fw-bold fs-6">{{ translate("Customers") }}</label>
                      <div class="col-lg-8 fv-row d-v-container">
                        <select
                          v-model="project.customerId"
                          class="form-select form-select-lg fw-bold fs-6 text-dark"
                        >
                          <option
                            class="text-dark"
                            :value="customer.Id"
                            selected
                          >
                            {{ customer.Name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row mb-4">
                      <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
                        translate("project_field_name_label")
                      }}</label>

                      <div class="col-lg-8 fv-row d-v-container">
                        <div class="fv-plugins-message-container d-v-content">
                          <div class="fv-help-block ms-2 v-element">
                            <ErrorMessage name="projectName" />
                          </div>
                        </div>
                        <Field
                          type="text"
                          name="projectName"
                          :class="`form-control form-control-lg fs-6 ${
                            errors['projectName'] !== undefined ? 'v-invalid' : ''
                          }`"
                          :placeholder="translate('project_field_name_label')"
                          v-model.trim="project.name"
                        />
                      </div>
                    </div>

                    <div class="row justify-content-end">
                      <div class="col-lg-8 fv-row">
                        <div class="form-check form-check-custom form-check-solid">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="check-remember"
                            v-model="project.published"
                          />
                          <div class="d-flex flex-column position-relative w-100">
                            <label
                              class="form-check-label col-form-label fw-bold p-0 mt-2"
                              for="check-remember"
                              style="margin-bottom: 15px"
                            >
                              {{ translate("customer_modal_check_label") }}
                            </label>
                            <label
                              class="form-check-label col-form-label fw-bold fs-7 p-0 text-gray-500"
                              for="check-remember"
                              style="position: absolute; margin-top: 20px"
                            >
                              {{ translate("project_modal_check_label_description") }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(item, index) in contentLanguages"
                    :key="index"
                    class="tab-pane fade"
                    :id="`${item.Value}`"
                    role="tabpanel"
                  >
                    <div class="row">
                      <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                        translate("project_field_name_label")
                      }}</label>
                      <div class="col-lg-8 fv-row">
                        <input
                          type="text"
                          :id="`name-${item.Id}`"
                          :name="item.Id"
                          class="form-control form-control-lg fs-6"
                          :placeholder="translate('project_field_name_label')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end pb-7 pe-10">
                <a
                  class="btn btn-white btn-active-light me-2 btn-sm fs-6 border"
                  @click="closeModal"
                >
                  {{ translate("Cancel") }}
                </a>
                <button
                  type="submit"
                  v-show="addUp"
                  class="btn btn-primary btn-sm fs-6 border"
                  :disabled="loading"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm mx-1"
                  ></div>
                  <span class="indicator-label">
                    {{ translate("Add") }}
                  </span>
                </button>
                <a
                  v-show="!addUp"
                  class="btn btn-sm btn-primary fs-6"
                  :class="`btn btn-primary border btn-sm fs-6 ${loading ? 'disabled' : ''}`"
                  @click="updateData"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm mx-1"
                  ></div>
                  <span class="indicator-label">
                    {{ translate("Save") }}
                  </span>
                </a>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, reactive, inject, defineProps, defineEmits, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import * as Yup from "yup";
import { hideModal } from "@/core/helpers/dom";

const props = defineProps({ prorjectId: Number });
const emit = defineEmits(["closeModal"]);

// Inject Props
const customer = inject("customer");
const loading = ref(false);

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

// Validation Tanımlaması
const projectValidator = Yup.object().shape({
  projectName: Yup.string().nullable().required(translate("CustomerAdd_Valid_FirstName")),
});

const store = useStore();

const newTargetModalRef = ref(null);
const refForm = ref(null);

// ! Content Languages
const closeModal = () => {
  hideModal(newTargetModalRef.value);
};

const clearForm = () => {
  setTimeout(() => {
    if (contentLanguages.value.length > 0) {
      contentLanguages.value.forEach((item) => {
        document.getElementById("name-" + item.Id).value = "";
      });
      contentLanguages.value.forEach((item) => {
        document.getElementById(item.Value).classList.remove("show", "active");
      });
      activeLink.value = "Standart";
      document.getElementById("kt_tab_pane_1").classList.add("show", "active");
    }
    addUp.value = true;
    title.value = "project_modal_add_title";
    project.Id = 0;
    project.name = null;
    project.locales = [];
    project.published = true;
    emit("closeModal");
  }, 300);
};

store.dispatch("LanguageModule/GET_LOCALİZATON");
const contentLanguages = computed(() => store.getters["LanguageModule/_getLocalizatonList"]);
const activeLink = ref("Standart");
const project = reactive({
  Id: 0,
  customerId: 0,
  name: null,
  locales: [],
  published: true,
});

const addUp = ref(true);
const title = ref("project_modal_add_title");
const block = ref(false);
const customerId = inject("customerId");

// ! Save Data
const saveData = () => {
  if (contentLanguages.value.length > 0) {
    contentLanguages.value.forEach((item) => {
      var value = document.getElementById("name-" + item.Id).value;
      var localobj = {
        languageId: "",
        name: "",
      };
      if (value !== "") {
        localobj.languageId = item.Id;
        localobj.name = value;
        project.locales.push(localobj);
      }
    });
  }
  store.dispatch("ProjectModule/ADD_PROJECT", project).then((response) => {
    if (response) {
      store.dispatch("ProjectModule/GET_ALL_PROJECTS", {
        page: 1,
        pageSize: 10,
        customerId: customerId,
      });
    }
  });
  closeModal();
};

// ! Update Data

watch(props, () => {
  if (props.prorjectId !== 0) {
    block.value = true;
    addUp.value = false;

    store.dispatch("ProjectModule/GET_PROJECT", props.prorjectId).then((response) => {
      title.value = response.Name;
      project.name = response.Name;
      project.Id = response.Id;
      project.published = response.Published;
      response.Locales.forEach((i) => (document.getElementById("name-" + i.LanguageId).value = i.Name));
      block.value = false;
    });
  }
});

const updateData = () => {
  if (contentLanguages.value.length > 0) {
    contentLanguages.value.forEach((item) => {
      var value = document.getElementById("name-" + item.Id).value;
      if (value !== "") {
        var localobj = {
          languageId: "",
          name: "",
        };
        localobj.languageId = item.Id;
        localobj.name = value;
        project.locales.push(localobj);
      }
    });
  }

  store.dispatch("ProjectModule/UPDATE_PROJECT", project).then((response) => {
    if (response) {
      store.dispatch("ProjectModule/GET_ALL_PROJECTS", {
        page: 1,
        pageSize: 10,
        customerId: customerId,
      });
    }
  });
  project.name = null;
  project.Id = 0;
  project.locales = [];
  closeModal();
};

onMounted(() => {
  project.customerId = customer.Id;
  document.getElementById("add-project-modal").addEventListener("hide.bs.modal", function () {
    clearForm();
    refForm.value.resetForm();
  });
});
</script>

<style></style>
